import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    IDatiqLog,
    IDatiqLogStateService
} from '../models';
import { DatiqLogStoreService } from '../store';

@Injectable({
    providedIn: 'root',
})
export class DatiqLogStateService implements IDatiqLogStateService {
    constructor(private _store: DatiqLogStoreService) {}
    log(message: string, info?: unknown): void {
        this._store.log(message, info);
    }
    error(message: string, info?: unknown): void {
        this._store.error(message, info);
    }
    warn(message: string, info?: unknown): void {
        this._store.warn(message, info);
    }
    debug(message: string, info?: unknown): void {
        this._store.debug(message, info);
    }

    jsError(message: string, error: Error, info: unknown) {
        this._store.jsError(message, error, info);
    }

    getLogs$(): Observable<IDatiqLog[]> {
        return this._store.getLogs$();
    }
}
